import React, { useEffect, useState, useRef } from 'react';
import { Bell, Plus, ArrowRight, MoveUpRight, Search, ChevronUp, ChevronDown, Eye, EyeOff, Download, X, EllipsisVerticalIcon, ChevronLeft, ChevronRight, FileDown } from 'lucide-react';
import logo1 from '../../assets/videos.png';
import logo4 from '../../assets/agent.png';
import logo2 from '../../assets/activat.png';
import logo3 from '../../assets/stock.png';
import car from '../../assets/images/container.png';
import fastag from '../../assets/fastaglogo.png';
import { Button } from '../../Common/Button';
import FitmentCertificateModal from '../../components/common/FitmentCertificateModal';
import hiicon from '../../assets/images/hi.png';
import FastagPurchase from '../../Commponent/FastagPurchase';
import CommonTable from '../../Common/CommonTable';
import AddAgent from '../../Commponent/AddAgent';
import BulkDistributorsModal from '../../Commponent/BulkDistributorsModal';
import { getVehicleClassData } from '../../Utils/helper';
import { vehicleClasses } from '../../Utils/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS } from '../../redux/actions';
import { ErrorToast, SuccessToast } from '../../Utils/toast';
import moment from 'moment/moment';
import SideModal from '../../Commponent/SideModal';
import AdminTableModal from '../../Commponent/AdminTableModal';
import { API } from '../../Common/Api';
import { useNavigate } from 'react-router-dom';
import { path } from '../../Utils/ScreenPath';

// Per-metric accent styling for the dashboard stat cards.
// Full literal class names are kept here so Tailwind's content scanner keeps them.
const STAT_ACCENTS = {
  "Total Purchased FASTags": { iconBg: "bg-indigo-50", bar: "from-indigo-500 to-indigo-300", glow: "bg-indigo-500/10", value: "text-indigo-600", hoverRing: "hover:ring-indigo-100" },
  "Distributor Assigned FASTags": { iconBg: "bg-emerald-50", bar: "from-emerald-500 to-emerald-300", glow: "bg-emerald-500/10", value: "text-emerald-600", hoverRing: "hover:ring-emerald-100" },
  "Dealer Assigned FASTags": { iconBg: "bg-violet-50", bar: "from-violet-500 to-violet-300", glow: "bg-violet-500/10", value: "text-violet-600", hoverRing: "hover:ring-violet-100" },
  "Agent Assigned FASTags": { iconBg: "bg-amber-50", bar: "from-amber-500 to-amber-300", glow: "bg-amber-500/10", value: "text-amber-600", hoverRing: "hover:ring-amber-100" },
  "Available Stock": { iconBg: "bg-rose-50", bar: "from-[#EE3B31] to-rose-300", glow: "bg-[#EE3B31]/10", value: "text-[#EE3B31]", hoverRing: "hover:ring-rose-100" },
};
const DEFAULT_ACCENT = { iconBg: "bg-gray-50", bar: "from-gray-400 to-gray-200", glow: "bg-gray-500/10", value: "text-gray-900", hoverRing: "hover:ring-gray-100" };

const DashboardAdmin = () => {
  const dispatch = useDispatch();
  const GetFastag = useSelector((state) => state.GetFastag.GetFastagData);
  const GetInventorySummary = useSelector((state) => state.GetInventorySummary.GetInventorySummaryData);
  const CreateDistributorBulk = useSelector((state) => state.CreateDistributorBulk.CreateDistributorBulkData);
  const DeniedRequest = useSelector((state) => state.DeniedRequest?.DeniedRequestData);
  const refreshCount = useSelector((state) => state.Refresh?.refreshCount);
  const [show, setShow] = useState(false);
  const [addMenuOpen, setAddMenuOpen] = useState(false);
  const [addAgentsOpen, setAddAgentsOpen] = useState(false);
  const [addBulkAgentsOpen, setAddBulkAgentsOpen] = useState(false);
  const [visibleRows, setVisibleRows] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedClass, setSelectedClass] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [checkGetFastag, setCheckGetFastag] = useState(false);
  const [tableData, setTableData] = useState([]);

  // const [sortKey, setSortKey] = useState("");
  // const [sortOrder, setSortOrder] = useState("asc");
  const [sortConfig, setSortConfig] = useState({ key: "", direction: null });
  const [show1, setShow1] = useState(false);
  const [userData, setUserData] = useState(null);
  const [file, setFile] = useState("");
  const [checkGetInventorySummary, setCheckGetInventorySummary] = useState(false);
  const [checkCreateDistributorBulk, setCheckCreateDistributorBulk] = useState(false);
  const [viewDetailsModalOpen, setViewDetailsModalOpen] = useState(false);
  const [viewDetailsItem, setViewDetailsItem] = useState(null);
  const [checkDeniedRequest, setCheckDeniedRequest] = useState(false);
  const [assigningAgent, setAssigningAgent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    getData()
    getDataInit()
    // Dispatch inventory summary API call
    setCheckGetInventorySummary(true)
    dispatch(ACTIONS.GetInventorySummaryAction());
  }, [refreshCount]);


  const getDataInit = async () => {
    const data = localStorage.getItem('UserDetail');


    setUserData(JSON.parse(data));
  }
  const getData = () => {
    let params = {
      page: 1,
      limit: 5,
    }
    setCheckGetFastag(true)
    dispatch(ACTIONS.GetFastagAction(params));
  }

  const refreshAll = () => {
    getData();
    setCheckGetInventorySummary(true);
    dispatch(ACTIONS.GetInventorySummaryAction());
  }

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction:
            prev.direction === "asc"
              ? "desc"
              : prev.direction === "desc"
                ? null
                : "asc",
        };
      }
      return { key, direction: "asc" };
    });
  };
  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === "asc")
        return (
          <ChevronUp className="w-[18px] h-[18px] inline-block ml-1 text-[#9C9C9C]" />
        );
      if (sortConfig.direction === "desc")
        return (
          <ChevronDown className="w-[18px] h-[18px] inline-block ml-1 text-[#9C9C9C]" />
        );
    }
    return (
      <ChevronDown className="w-[18px] h-[18px] inline-block ml-1 text-[#E0E0E0]" />
    );
  };



  useEffect(() => {
    if (checkGetFastag) {
      if (GetFastag?.status == 200 && GetFastag?.success) {
        setTableData(GetFastag?.data.data);
      } else {
        ErrorToast(GetFastag?.message);
      }
      setCheckGetFastag(false)
      // setLoading(false);
    }
  }, [GetFastag])

  useEffect(() => {
    if (checkGetInventorySummary) {
      if (GetInventorySummary?.status == 200 && GetInventorySummary?.success) {
        // Inventory summary loaded successfully
      } else {
        ErrorToast(GetInventorySummary?.message);
      }
      setCheckGetInventorySummary(false)
    }
  }, [GetInventorySummary])

  // Handle CreateDistributorBulk response
  useEffect(() => {
    if (CreateDistributorBulk && checkCreateDistributorBulk) {
      // Check if the API call was successful (status 200)
      if (CreateDistributorBulk?.status === 200) {
        const { message, inserted, failed, details } = CreateDistributorBulk;

        // Create detailed success message based on status only
        let detailedMessage = `${message || 'Bulk distributor upload completed'}. Successfully added: ${inserted || 0} distributors`;

        // Add failure information if any
        if (failed && failed > 0) {
          detailedMessage += `, Failed: ${failed}`;

          // Show detailed failure information only if there are actual failures
          if (details?.failed && Array.isArray(details.failed) && details.failed.length > 0) {
            const failureReasons = details.failed.map(failure => {
              // Handle your API structure: failure.data contains the original row data
              const username = failure.data?.username || 'Unknown';
              const reason = failure.reason || 'Unknown error';
              const rowNumber = failure.row || 'Unknown row';
              return `Row ${rowNumber} (${username}): ${reason}`;
            }).join('; ');

            // Show warning toast for failures
            setTimeout(() => {
              ErrorToast(`Failed entries: ${failureReasons}`);
            }, 1000);
          }
        }

        // Show success toast for status 200
        SuccessToast(detailedMessage);
        refreshAll(); // Refresh table and stats
        setAddBulkAgentsOpen(false); // Close modal
        setFile(''); // Reset file
      } else {
        // Handle error cases (400, 500, etc.)
        const errorMessage = CreateDistributorBulk?.message || CreateDistributorBulk?.error || 'Failed to create bulk distributors';
        ErrorToast(errorMessage);
        // Keep modal open for user to fix issues
      }

      setCheckCreateDistributorBulk(false);
    }
  }, [CreateDistributorBulk, checkCreateDistributorBulk])

  const toggleVisibility = (index, row) => {
    const isVisible = visibleRows[index];
    const newVisibility = { ...visibleRows, [index]: !isVisible };
    setVisibleRows(newVisibility);

    // Open modal for both mobile and desktop
    setModalOpen(!isVisible);

    if (!isVisible) {
      setSelectedClass(row);
      setSelectedIndex(index);
    }
  };

  const handleSubmit = () => {
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      setCheckCreateDistributorBulk(true);
      dispatch(ACTIONS.CreateDistributorBulkAction(formData));
    } else {
      ErrorToast('Please select a file to upload.');
    }
  }


  const SubmitButton = () => {
    return (
      <button
        onClick={handleSubmit}
        className="mt-2 bg-[#EE3B31] text-white rounded-full py-2"
      >
        Submit
      </button>
    )
  }
  const handleUpload = (fileRaw) => {
    setFile(fileRaw);
  }


  const vehicleData = getVehicleClassData(selectedClass.vehicleClass);

  const tableColumns = [
    {
      label: "Requested By",
      key: "name",
      render: (row) => (
        <div>
          <div className="font-medium text-[#1F1715]">{row.user?.username}</div>
          <div className="text-xs text-[#000000]">{row.user?.batchId}</div>
        </div>
      ),
    },
    { label: "Mobile Number", render: (row) => row.user?.mobileNo },
    {
      label: (
        <div
          className="flex items-center gap-1 cursor-pointer"
          onClick={() => handleSort("vehicleClass")}
        >
          Vehicle Class {getSortIcon("vehicleClass")}
        </div>
      ),
      key: "vehicleClass",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img
              src={vehicleClassData?.tagimage}
              alt="Tag"
              className="w-[34px]"
            />
            <p>{vehicleClassData.value}</p>
            <div
              className="pl-2 flex items-center cursor-pointer"
              onClick={() => toggleVisibility(idx, item)}
            >
              {visibleRows[idx] ? <Eye className="h-5 w-5" /> : <EyeOff className="h-5 w-5" />}
            </div>
          </div>
        );
      },
    },
    { label: "Requested Date", render: (row) => moment(row.createdAt).format("DD MMMM, YYYY, hh:mm A"), },
    { label: "Quantity", key: "quantity" },
    // { label: "Status", key: "status" },
    {
      label: "Payment Proof",
      render: (row) => {
        if (row.utrnumber) return row.utrnumber.slice(-10);
        if (row.fileUrl) {
          return (
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleSecureDownload(row.fileUrl);
              }}
              className="text-blue-500 hover:text-blue-700 hover:underline cursor-pointer bg-transparent border-none p-0 font-medium whitespace-nowrap"
            >
              View Screenshot
            </button>
          );
        }
        return '-';
      }
    },
    { label: "Transferred Amount", key: "transferredAmount" },
    {
      label: "Action",
      key: "assign",
      tdClassName: 'flex justify-end gap-2',
      render: (row) => (
        <div className="flex gap-2">
          {row.status === "Unassigned" ? (
            <div className="flex gap-2">
              <Button
                label="Approve Now"
                onClick={() => {
                  setAssigningAgent(row);
                  setIsModalOpen(true);
                }}
                roundedButton
                className="!bg-green-500 hover:!bg-green-600 !text-white rounded-full px-3 py-2"
              />
              <Button
                label="Reject"
                onClick={() => handleDeny(row)}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded-full text-sm"
              />
            </div>
          ) : (
            <button
              className="text-blue-600 text-sm font-semibold hover:underline px-4 py-2"
              onClick={() => {
                setViewDetailsItem(row);
                setViewDetailsModalOpen(true);
              }}
            >
              View Details
            </button>
          )}
        </div>
      ),
    }

  ];

  // Create dynamic statsData from API data
  const getStatsData = () => {
    if (GetInventorySummary?.success && GetInventorySummary?.data) {
      const data = GetInventorySummary.data;
      return [
        {
          id: 1,
          title: "Total Purchased FASTags",
          value: data.totalFastag?.count || 0,
          iconColor: logo1
        },
        {
          id: 2,
          title: "Distributor Assigned FASTags",
          value: data.distributorAssigned?.count || 0,
          iconColor: logo2
        },
        {
          id: 5,
          title: "Dealer Assigned FASTags",
          value: data.dealerAssigned?.count || 0,
          iconColor: logo2
        },
        {
          id: 4,
          title: "Agent Assigned FASTags",
          value: data.agentAssigned?.count || 0,
          iconColor: logo4
        },
        {
          id: 3,
          title: "Available Stock",
          value: (data.availableStock?.count || 0),
          iconColor: logo3
        },
      ];
    }
    // Fallback to N/A while loading or on error
    return [
      { id: 1, title: "Total Purchased FASTags", value: "N/A", iconColor: logo1 },
      { id: 2, title: "Distributor Assigned FASTags", value: "N/A", iconColor: logo2 },
      { id: 5, title: "Dealer Assigned FASTags", value: "N/A", iconColor: logo2 },
      { id: 4, title: "Agent Assigned FASTags", value: "N/A", iconColor: logo4 },
      { id: 3, title: "Available Stock", value: "N/A", iconColor: logo3 },
    ];
  };

  const statsData = getStatsData();

  // Profile data
  const profileData = {
    name: "Your Profile",
    status: userData?.username || userData?.role,
    phone: userData?.mobileNo ? `+91 ${userData.mobileNo}` : '',
    message: "Continue your journey and achieve your target",
  };




  // Handle deny action
  const handleDeny = (agent) => {
    if (window.confirm(`Are you sure you want to deny the request from ${agent.user?.username}?`)) {
      const data = {
        FasTagId: agent._id,
        status: "Rejected"
      };

      setCheckDeniedRequest(true);
      dispatch(ACTIONS.DeniedRequestAction(JSON.stringify(data)));
    }
  }

  // Watch for DeniedRequest response
  useEffect(() => {
    if (checkDeniedRequest && DeniedRequest) {
      if (DeniedRequest.status === 200 && DeniedRequest.success) {
        SuccessToast(DeniedRequest.message || 'Request denied successfully');
        refreshAll(); // Refresh the data and stats
      } else if (DeniedRequest.message) {
        ErrorToast(DeniedRequest.message);
      }
      setCheckDeniedRequest(false);
    }
  }, [DeniedRequest]);

  // Secure file download handler
  const handleSecureDownload = async (fileUrl) => {
    if (!fileUrl) {
      ErrorToast('No file URL available');
      return;
    }

    try {
      // Prepare the request body with the file URL
      const requestBody = JSON.stringify({
        InventoryExcleURL: fileUrl
      });

      // Call the secure download API
      const blob = await API.DownloadFile(requestBody);

      // Create download link
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;

      // Extract filename from URL or use a default name
      const urlParts = fileUrl.split('/');
      const filename = urlParts[urlParts.length - 1] || 'screenshot.jpg';
      link.download = filename;

      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the object URL
      window.URL.revokeObjectURL(downloadUrl);

      SuccessToast('File downloaded successfully');
    } catch (error) {
      console.error('Download failed:', error);
      ErrorToast('Failed to download file. Please try again.');
    }
  }
  const navigate = useNavigate();
  const [fitmentOpen, setFitmentOpen] = useState(false);
  const onboardMenuRef = useRef(null);

  // Close onboard menu when clicking outside
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (onboardMenuRef.current && !onboardMenuRef.current.contains(e.target)) {
        setAddMenuOpen(false);
      }
    };
    if (addMenuOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [addMenuOpen]);

  return (
    <>
      {fitmentOpen && <FitmentCertificateModal onClose={() => setFitmentOpen(false)} />}
      <div className="">
        <div className="mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-4 xl:gap-6 lg:gap-2 gap-6">
            <div className="lg:col-span-3">
              <div className="flex flex-col mb-[16px]">
                <div className="flex justify-end">
                  <div className="flex items-center gap-3 hidden md:flex">
                    <Button
                      label="Download Fitment Certificate"
                      icon={<FileDown className="w-4 h-4" />}
                      iconPosition="right"
                      roundedButton={true}
                      onClick={() => setFitmentOpen(true)}
                      style={{ backgroundColor: "#EE3B31", fontWeight: "700" }}
                    />

                    <div className="relative inline-block" ref={onboardMenuRef}>
                      <Button
                        label="Onboard Distributor(BC Partner)"
                        icon={<Plus className="w-4 h-4" />}
                        iconPosition="right"
                        roundedButton
                        onClick={(e) => {
                          e.stopPropagation();
                          setAddMenuOpen((prev) => !prev);
                        }}
                        style={{ backgroundColor: "#EE3B31", fontWeight: "700" }}
                      />

                      {addMenuOpen && (
                        <div
                          className="absolute right-0 mt-2 bg-white border rounded shadow z-[500] min-w-max"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            onClick={() => {
                              setAddMenuOpen(false);
                              setShow1(true);
                            }}
                            className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm whitespace-nowrap cursor-pointer"
                          >
                            Add Distributor(BC Partner) +
                          </button>
                          <button
                            onClick={() => {
                              setAddMenuOpen(false);
                              setAddBulkAgentsOpen(true);
                            }}
                            className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm whitespace-nowrap cursor-pointer"
                          >
                            Add Bulk Distributor(BC Partner) +
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative overflow-hidden rounded-2xl text-white my-[16px] min-h-[172px] shadow-lg">
                <div
                  className="absolute inset-0 bg-cover bg-no-repeat bg-center scale-105"
                  style={{ backgroundImage: `url(${car})` }}
                ></div>
                {/* Brand-tinted gradient keeps the copy readable over the photo */}
                <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-transparent"></div>
                <div className="absolute -top-10 -right-10 w-44 h-44 rounded-full bg-[#EE3B31]/30 blur-3xl"></div>
                <div className="relative z-10 h-full flex flex-col justify-center px-[28px] py-[26px]">
                  <h1 className="text-2xl md:text-3xl font-bold mb-1 tracking-tight">Track FASTag &amp; Manage Agents</h1>
                  <p className="text-sm md:text-base text-white/80">Grow with Omnicard.</p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-[14px]">
                {statsData.map((stat, index) => {
                  const accent = STAT_ACCENTS[stat.title] || DEFAULT_ACCENT;
                  const isWide = stat.title === "Available Stock";
                  return (
                    <div
                      key={stat.id}
                      className={`group relative overflow-hidden bg-white rounded-2xl border border-gray-100 shadow-sm ring-1 ring-transparent ${accent.hoverRing} hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 ${isWide ? "md:col-span-2" : ""}`}
                      style={{ padding: "20px" }}
                    >
                      {/* left accent bar */}
                      <div className={`absolute left-0 top-0 h-full w-1 bg-gradient-to-b ${accent.bar}`}></div>
                      {/* soft glow on hover */}
                      <div className={`absolute -right-6 -top-6 w-24 h-24 rounded-full ${accent.glow} blur-2xl opacity-0 group-hover:opacity-100 transition-opacity`}></div>
                      <div className="relative flex items-center gap-4">
                        <div className={`shrink-0 rounded-2xl ${accent.iconBg} flex items-center justify-center`} style={{ width: "58px", height: "58px" }}>
                          <img
                            src={stat.iconColor}
                            alt=""
                            className={index === 1 ? "w-[26px] h-[30px]" : "w-[30px] h-[30px]"}
                          />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-gray-500 text-sm font-medium mb-1 truncate">{stat.title}</p>
                          <p className={`text-3xl font-extrabold tracking-tight ${accent.value}`}>{stat.value}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Profile Section */}
            <div className="w-full hidden md:block">
              <div className="relative overflow-hidden bg-white rounded-2xl shadow-sm border border-gray-100 min-h-[444px]">
                {/* gradient header banner */}
                <div className="absolute inset-x-0 top-0 h-28 bg-gradient-to-br from-[#EE3B31] to-rose-400"></div>
                <div className="relative flex flex-col min-h-[444px] p-[25px]">
                  <div className="flex items-center justify-between mb-8">
                    <h3 className="font-semibold text-white text-lg md:text-xl">{profileData.name}</h3>
                  </div>

                  <div className="flex justify-center mb-4">
                    <div className="p-1.5 rounded-full bg-white shadow-lg ring-4 ring-white">
                      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-rose-50 to-indigo-50 flex items-center justify-center">
                        <img
                          src={hiicon}
                          className="w-14 h-14 object-contain"
                          alt="Hi Icon"
                          onError={(e) => (e.target.style.display = 'none')}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-center mb-2">
                    <h4 className="text-xl font-bold text-gray-900 mb-1">{profileData.status}</h4>
                  </div>

                  <div className="text-center mt-3">
                    <p className="text-gray-500 text-sm leading-relaxed whitespace-pre-line px-2">
                      {profileData.message}
                    </p>
                  </div>

                  <div className="mt-auto pt-6 border-t border-gray-100 text-center">
                    <img
                      src={fastag}
                      className="h-8 object-contain mx-auto"
                      alt="Fastag"
                      onError={(e) => (e.target.style.display = 'none')}
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        {modalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
            <div className="relative bg-white rounded-[20px] shadow-lg w-full max-w-xl max-h-[90vh] overflow-y-auto">
              <div className="p-4 md:p-6">
                <div className="absolute top-4 right-4 gap-3 flex-row flex">
                  <button
                    onClick={() => {
                      setModalOpen(false);
                      if (selectedIndex !== null) {
                        toggleVisibility(selectedIndex, selectedClass);
                      }
                    }}
                    className="text-gray-600 hover:text-red-500 p-1"
                  >
                    <X size={18} className="md:w-5 md:h-5" />
                  </button>
                </div>
                <h2 className="text-lg md:text-xl font-semibold mb-[4px] text-center pr-16">
                  {vehicleData?.value}
                </h2>
                <p className="mb-[20px] md:mb-[30px] text-xs md:text-sm text-center px-2">
                  {vehicleData?.description}
                </p>
                <div className="relative w-full flex justify-center items-center py-8 px-4">
                  <div className="relative bg-white p-8 rounded-2xl shadow-2xl border border-gray-200 max-w-2xl w-full">
                    {/* Decorative corner accents */}
                    <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-red-500 rounded-tl-2xl opacity-20"></div>
                    <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-red-500 rounded-br-2xl opacity-20"></div>

                    {/* Image container with classic frame */}
                    <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl border-2 border-gray-300 shadow-inner">
                      <img
                        src={vehicleData?.cardWebp}
                        alt={vehicleData?.name}
                        className="w-full h-auto object-contain rounded-lg transition-transform duration-500 hover:scale-[1.12]"
                      />
                    </div>

                    {/* Elegant bottom accent */}
                    <div className="mt-6 flex justify-center">
                      <div className="h-1 w-24 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <AdminTableModal
          key={isModalOpen ? assigningAgent?._id || 'open' : 'closed'}
          open={isModalOpen}
          onClose={() => { setIsModalOpen(false); refreshAll(); }}
          title={`${assigningAgent?.user?.username} • Requested: ${assigningAgent?.quantity || 0} FASTags`}
          distributorName={assigningAgent?.user?.username}
          distributorId={assigningAgent?.user?._id}
          requestId={assigningAgent?._id}
          maxQuantity={assigningAgent?.quantity}
          reqVehicleClass={assigningAgent?.vehicleClass}
          mobile={assigningAgent?.user?.mobileNo}
          utr={assigningAgent?.utrnumber}
          date={moment(assigningAgent?.createdAt).format('DD MMM, YYYY')}
          fileUrl={assigningAgent?.fileUrl}
          showSearch={true}
        />

        {/* View Details Side Modal */}
        {viewDetailsModalOpen && (
          <SideModal
            onClose={() => {
              setViewDetailsModalOpen(false);
              setViewDetailsItem(null);
            }}
            title={`FASTag Request Details: ${viewDetailsItem?.user?.username}`}
            setModalOpen={setViewDetailsModalOpen}
          >
            {viewDetailsItem && (
              <div className="space-y-4">
                {/* Request Information */}
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="text-lg font-semibold mb-3 text-gray-800">Request Information</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <span className="text-sm font-medium text-gray-600">Status:</span>
                      <div className="text-gray-800 font-medium">
                        <span className={`inline-block px-2 py-1 rounded-full text-xs ${viewDetailsItem.status === 'Assigned'
                          ? 'bg-green-100 text-green-800'
                          : viewDetailsItem.status === 'Rejected'
                            ? 'bg-red-100 text-red-800'
                            : 'bg-gray-100 text-gray-800'
                          }`}>
                          {viewDetailsItem.status}
                        </span>
                      </div>
                    </div>
                    <div>
                      <span className="text-sm font-medium text-gray-600">Vehicle Class:</span>
                      <div className="text-gray-800 font-medium">{viewDetailsItem.vehicleClass}</div>
                    </div>
                    <div>
                      <span className="text-sm font-medium text-gray-600">Requested Date:</span>
                      <div className="text-gray-800">{moment(viewDetailsItem.createdAt).format('DD MMMM, YYYY, hh:mm A')}</div>
                    </div>
                  </div>
                </div>

                {/* User Information */}
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="text-lg font-semibold mb-3 text-blue-800">User Information</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <span className="text-sm font-medium text-gray-600">Name:</span>
                      <div className="text-gray-800 font-medium">{viewDetailsItem.user?.username}</div>
                    </div>
                    <div>
                      <span className="text-sm font-medium text-gray-600">Mobile Number:</span>
                      <div className="text-gray-800 font-mono">{viewDetailsItem.user?.mobileNo}</div>
                    </div>
                  </div>
                </div>

                {/* Transaction Information */}
                <div className="bg-green-50 p-4 rounded-lg">
                  <h3 className="text-lg font-semibold mb-3 text-green-800">Transaction Information</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <span className="text-sm font-medium text-gray-600">Quantity:</span>
                      <div className="text-gray-800 font-semibold text-lg">{viewDetailsItem.quantity}</div>
                    </div>
                    <div>
                      <span className="text-sm font-medium text-gray-600">Total Amount:</span>
                      <div className="text-gray-800 font-semibold text-lg text-green-600">₹{viewDetailsItem.transferredAmount || 0}</div>
                    </div>
                    <div className="md:col-span-2">
                      <span className="text-sm font-medium text-gray-600">UTR Number:</span>
                      <div className="text-gray-800 font-mono bg-white p-2 rounded border">{viewDetailsItem.utrnumber}</div>
                    </div>
                    <label className="block text-sm font-medium text-gray-700 ">ScreenShorts :
                      <button
                        onClick={() => handleSecureDownload(viewDetailsItem?.fileUrl)}
                        className='text-blue-500 hover:text-blue-700 hover:underline cursor-pointer bg-transparent border-none p-0'
                        disabled={!viewDetailsItem?.fileUrl}
                      >
                        {viewDetailsItem?.fileUrl ? '  Download ' : ' No file available '}
                      </button>
                    </label>
                  </div>
                </div>

                {/* Additional Details */}
                {((viewDetailsItem.remark && viewDetailsItem.remark.toLowerCase() !== 'assigned by admin') || viewDetailsItem.notes) && (
                  <div className="bg-yellow-50 p-4 rounded-lg">
                    <h3 className="text-lg font-semibold mb-3 text-yellow-800">Additional Information</h3>
                    {(viewDetailsItem.remark && viewDetailsItem.remark.toLowerCase() !== 'assigned by admin') && (
                      <div className="mb-2">
                        <span className="text-sm font-medium text-gray-600">Remark:</span>
                        <div className="text-gray-800">{viewDetailsItem.remark}</div>
                      </div>
                    )}
                    {viewDetailsItem.notes && (
                      <div>
                        <span className="text-sm font-medium text-gray-600">Notes:</span>
                        <div className="text-gray-800">{viewDetailsItem.notes}</div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </SideModal>
        )}

      </div>

      {/* Table Header */}
      <div className="min-w-auto bg-[#FFFFFF] rounded-t-2xl shadow-sm border border-gray-100 border-b-0 mt-[16px] md:mt-10">
        <div className="flex justify-between items-center px-[24px] py-[18px]">
          <div className="flex items-center gap-3">
            <span className="w-1.5 h-6 rounded-full bg-[#EE3B31]"></span>
            <h2 className="text-lg md:text-xl font-semibold text-gray-900">My Fastag Request</h2>
          </div>
          <button
            onClick={() => navigate('/fastag-request')}
            title="View all requests"
            className="group rounded-full w-9 h-9 flex justify-center items-center bg-[#F5F5F5] hover:bg-[#EE3B31] transition-colors"
          >
            <MoveUpRight className="w-[18px] h-[18px] text-[#EE3B31] group-hover:text-white transition-colors" />
          </button>
        </div>
      </div>

      {/* Table */}
      <CommonTable columns={tableColumns} data={tableData} emptyMessage="No Inventory Found" />
      {show && <FastagPurchase onClose={() => setShow(false)} />}
      {show1 && <AddAgent title='Add Distributor(BC Partner) +' modalOpen={show1} api='CreateDistributor' setModalOpen={setShow1} onClose={() => { setShow1(false); getData() }} />}
      {addBulkAgentsOpen && (
        <BulkDistributorsModal
          isOpen={addBulkAgentsOpen}
          onClose={() => setAddBulkAgentsOpen(false)}
          onUpload={handleUpload}
          BottomComponent={SubmitButton}
        />
      )}
    </>
  );
};

export default DashboardAdmin;
